import { createSlice } from '@reduxjs/toolkit';
import packageJSON from '../../../../package.json';
import EnvService from '../../../services/EnvService';

const initialState = {
	version: packageJSON?.version,
	theme: 'light',
	token: '',
	currencies: [],
	availableCurrencies: [],
	availableCurrenciesLoading: false,
	viewsBalances: false,
	externalId: '',
	initDataTG: '',
	quotes: [],
	billingBalance: 0,
	tariffData: {},
	pinConfirm: {},
	publicConfig: {},
	modals: [],
	captchaConfirmRequestData: null,
	permissions: {},
	devices: [],
	isItTelegram: false,
	isPWA: false,
	deviceInfo: {},
	wsAmlResult: null,
};

export const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		resetState: state => ({
			...initialState,
			version: state.version,
			theme: state.theme,
			externalId: state.externalId,
			initDataTG: state.initDataTG,
			publicConfig: state.publicConfig,
			isItTelegram: state.isItTelegram,
			isPWA: state.isPWA,
		}),
		updatePublicConfig: (state, action) => {
			const { payload: publicConfig } = action;
			state.publicConfig = publicConfig;
		},
		setVersion: (state, action) => {
			const { payload: version } = action;
			state.version = version;
		},
		setIsPWA: (state, action) => {
			const { payload: isPWA } = action;
			state.isPWA = isPWA;
		},
		updateModalsStructure: (state, action) => {
			const { payload: models = {} } = action;
			state.modals = models;
		},
		addModal: (state, action) => {
			const { payload: model = {} } = action;
			state.modals.push({ id: createUniqModalId(), ...model });
		},

		closeLastModal: (state, action) => {
			state.modals.pop();
		},
		closeAllModals: state => {
			state.modals = [];
		},
		setExternalId: (state, action) => {
			const { payload: externalId } = action;
			state.externalId = externalId;
		},
		setInitDataTG: (state, action) => {
			const { payload: initDataTG } = action;
			state.initDataTG = initDataTG;
		},
		setCurrencies: (state, action) => {
			const { payload: currencies = initialState.currencies } = action;
			state.currencies = currencies;
		},
		setAvailableCurrencies: (state, action) => {
			const { payload: availableCurrencies = initialState.availableCurrencies } = action;
			state.availableCurrencies = availableCurrencies;
		},
		setDevices: (state, action) => {
			const { payload: devices = initialState.devices } = action;
			state.devices = devices;
		},
		setAvailableCurrenciesLoading: (state, action) => {
			state.availableCurrenciesLoading = action.payload;
		},
		setViewsBalances: (state, action) => {
			const { payload: viewsBalances } = action;
			state.viewsBalances = viewsBalances;
		},
		setToken: (state, action) => {
			const { payload: token } = action;
			state.token = token;
		},
		setTheme: (state, action) => {
			const { payload: theme } = action;
			EnvService?.SetColorScheme(theme);
			state.theme = theme;
		},
		setQuotes: (state, action) => {
			const { payload: quotes } = action;
			state.quotes = quotes;
		},
		setBillingBalance: (state, action) => {
			const { payload: billingBalance = initialState.billingBalance } = action;
			state.billingBalance = billingBalance;
		},
		setTariffData: (state, action) => {
			const { payload: tariffData = initialState.tariffData } = action;
			state.tariffData = tariffData;
		},
		setPinConfirm: (state, action) => {
			const { payload: pinConfirm = initialState.pinConfirm } = action;
			state.pinConfirm = pinConfirm;
		},
		setPinConfirmProps: (state, action) => {
			const { payload: pinConfirmPropses = {} } = action;
			state.pinConfirm = { ...state.pinConfirm, ...pinConfirmPropses };
		},
		setCaptchaConfirmRequestData: (state, action) => {
			const { payload: captchaConfirmRequestData = initialState.captchaConfirmRequestData } = action;
			state.captchaConfirmRequestData = captchaConfirmRequestData;
		},
		setUserPermissions: (state, action) => {
			const { payload: permissions = initialState.permissions } = action;
			state.permissions = permissions;
		},
		setisItTelegram: (state, action) => {
			const { payload: isItTelegram = initialState.isItTelegram } = action;
			state.isItTelegram = isItTelegram;
		},
		setDeviceInfo: (state, action) => {
			const { payload: deviceInfo = initialState.deviceInfo } = action;
			state.deviceInfo = deviceInfo;
		},
		setWsAmlResult: (state, action) => {
			const { payload: wsAmlResult = initialState.wsAmlResult } = action;
			state.wsAmlResult = wsAmlResult;
		},
	},
});

let uniqModalIndex = 1;
function createUniqModalId() {
	return `modal_${uniqModalIndex++}`;
}
